import { render, staticRenderFns } from "./UserRealList.vue?vue&type=template&id=3893f656&"
import script from "./UserRealList.vue?vue&type=script&lang=js&"
export * from "./UserRealList.vue?vue&type=script&lang=js&"
import style0 from "./UserRealList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports